import { render } from "./five-blocks-section.vue?vue&type=template&id=302565ca"
import script from "./five-blocks-section.vue?vue&type=script&lang=js"
export * from "./five-blocks-section.vue?vue&type=script&lang=js"

import "./five-blocks-section.vue?vue&type=style&index=0&id=302565ca&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__